<p-card class="p-card container">
  <h3 i18n>Informations et coordonnées</h3>

  <form [formGroup]="form">
    <div class="layout__inner-card margin--bottom-medium">
      <div class="layout--gap margin--bottom-medium">
        <div class="layout--full-width">
          <label class="label-top" for="firstName" i18n>Prénom</label>
          <input
            [ngClass]="{
              'error--input': form.controls.firstName.invalid && form.controls.firstName.touched,
            }"
            i18n-placeholder
            placeholder="Prénom"
            formControlName="firstName"
            id="firstName"
            type="text"
            [maxLength]="25"
            pInputText />
          @if (form.controls.firstName.touched) {
            @if (form.controls.firstName.hasError('maxlength')) {
              <p class="error margin--top-smaller" i18n>Maximum de 25 caractères</p>
            }
            @if (form.controls.firstName.hasError('noSpecialCharacterInvalid')) {
              <p class="error margin--top-smaller" i18n>Aucun caractère spécial</p>
            }
            @if (form.controls.firstName.hasError('noNumberInvalid')) {
              <p class="error margin--top-smaller" i18n>Aucun chiffre n'est permis</p>
            }
          }
        </div>

        <div class="layout--full-width">
          <label class="label-top" for="lastName" i18n>Nom de famille</label>
          <input
            [ngClass]="{
              'error--input': form.controls.lastName.invalid && form.controls.lastName.touched,
            }"
            i18n-placeholder
            placeholder="Nom de famille"
            formControlName="lastName"
            id="lastName"
            type="text"
            [maxLength]="25"
            pInputText />
          @if (form.controls.lastName.touched) {
            @if (form.controls.lastName.hasError('maxlength')) {
              <p class="error margin--top-smaller" i18n>Maximum de 25 caractères</p>
            }
            @if (form.controls.lastName.hasError('noSpecialCharacterInvalid')) {
              <p class="error margin--top-smaller" i18n>Aucun caractère spécial</p>
            }
            @if (form.controls.lastName.hasError('noNumberInvalid')) {
              <p class="error margin--top-smaller" i18n>Aucun chiffre n'est permis</p>
            }
          }
        </div>

        <div class="layout--full-width">
          <label class="label-top" for="preferredLanguage" i18n>Langue</label>
          <p-dropdown
            [options]="languageOptions | emTranslate"
            i18n-placeholder
            placeholder="Choisir"
            formControlName="preferredLanguage"
            id="preferredLanguage"
            optionLabel="name"
            optionValue="value"></p-dropdown>
        </div>
      </div>

      <div class="layout--gap">
        <div class="layout--full-width">
          <label class="label-top" for="email" i18n>Adresse courriel personnelle</label>
          <input
            [ngClass]="{
              'error--input': form.controls.email.invalid && form.controls.email.touched,
            }"
            i18n-placeholder
            placeholder="Adresse courriel"
            formControlName="email"
            id="email"
            type="text"
            pInputText />
        </div>

        <div class="layout--full-width">
          <label class="label-top" for="assistantEmails" i18n>Adresse courriel assistant(e)</label>
          <input
            [ngClass]="{
              'error--input': form.controls.assistantEmails.invalid && form.controls.assistantEmails.touched,
            }"
            [formControl]="form.controls.assistantEmails.controls[0]"
            i18n-placeholder
            placeholder="Adresse courriel"
            id="assistantEmails"
            type="text"
            pInputText />
        </div>
      </div>
    </div>

    <div class="layout__inner-card">
      <div class="margin--bottom-medium">
        <div class="layout--full-width">
          <label class="label-top" for="officeAddress" i18n>Adresse bureau</label>
          <input
            i18n-placeholder
            placeholder="Adresse de bureau"
            formControlName="officeAddress"
            id="officeAddress"
            type="text"
            pInputText />
        </div>
      </div>

      <div class="layout--full-width">
        <label class="label-top" for="personalAddress" i18n>Adresse personnelle</label>
        <input
          i18n-placeholder
          placeholder="Adresse personnelle"
          formControlName="personalAddress"
          id="personalAddress"
          type="text"
          pInputText />
      </div>
    </div>
  </form>
</p-card>
